import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import api from "@home/api";

export enum GoTo {
    calendar = "calendar",
    workflow = "workflow",
    proccesingWorkflow = "proccesing",
    mail = "mail",
    todo = "todo",
    survey = "survey",
    coWorking = "coworking",
}

@Component({})
export default class MyCountWebpart extends Vue {
    @Prop({ type: Boolean, default: false }) isMailUser!: boolean;

    counts: home.homeWebpartCount = {
        unreadMailCount: 0,
        workflowCount: {
            pending: 0,
            processing: 0,
            reference: 0
        },
        scheduleCount: 0,
        coWorkingCount: {
            totalCount: 0,
            responsible: 0,
            approver: 0,
            registrant: 0
        }
    };

    get workflowTotalCount(): number {
        return this.counts.workflowCount.pending + this.counts.workflowCount.processing + this.counts.workflowCount.reference;
    }

    created() {
        api.home.getCount().then((res) => {
            this.counts = res;
        });
    }

    onClickedIcon(value: GoTo) {
        const openExternal = (url: string) => window.open(url, "_blank");

        const findMenuItem = (
            menus: appbase.cache.TMenuItem[],
            predicate: (m: appbase.cache.TMenuItem) => boolean
        ): appbase.cache.TMenuItem | null => {
            for (const m of menus) {
                if (predicate(m)) return m;
                if (m.hasChildren) {
                    const sub = findMenuItem(m.children, predicate);
                    if (sub) return sub;
                }
            }
            return null;
        };

        let routePath = "";

        switch (value) {
            case GoTo.calendar:
                openExternal("https://outlook.office.com/calendar");
                return;
            case GoTo.mail:
                openExternal("https://outlook.office.com/mail");
                return;
            case GoTo.workflow: {
                const id = findMenuItem(this.portalCache.menu.items, m =>
                    m.baseUrl?.toLowerCase().includes("workflow") ?? false
                );
                if (id) {
                    routePath = `/workflow/page/home?MENUID=${id.menuId}&SYSID=1&_t=${Date.now()}`;
                } else {
                    (window as any).alertAsync(this.$t("관리자에게_문의하세요."));
                    return;
                }
                break;
            }
            case GoTo.survey: {
                const id = findMenuItem(this.portalCache.menu.items, m =>
                    m.targetUrl?.includes("survey") ?? false
                );
                routePath = window.location.origin;
                if (process.env.NODE_ENV === "production") routePath += "/po";
                if (id) {
                    routePath += `/survey/list?type=1&MENUID=${id.menuId}`;
                } else {
                    (window as any).alertAsync(this.$t("관리자에게_문의하세요."));
                    return;
                }
                break;
            }
            case GoTo.coWorking: {
                const id = findMenuItem(this.portalCache.menu.items, m =>
                    m.baseUrl?.toLowerCase().includes("task") ?? false
                );
                if (id) {
                    routePath = `/task/main?MENUID=${id.menuId}`;
                } else {
                    (window as any).alertAsync(this.$t("관리자에게_문의하세요."));
                    return;
                }
                break;
            }
            default:
                return;
        }

        window.location.href = routePath;
    }
}
